"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const FlagImage_1 = __importDefault(require("./FlagImage"));
const Wrapper_1 = __importDefault(require("./Wrapper"));
const Value = ({ flag, name, phoneCode, flagsHost }) => {
    return ((0, jsx_runtime_1.jsxs)(Wrapper_1.default, { children: [(0, jsx_runtime_1.jsx)(FlagImage_1.default, { src: `${flagsHost}/${flag}`, height: 22, width: 22, alt: name }), phoneCode] }));
};
exports.default = Value;
//# sourceMappingURL=index.js.map